<template>
  <header class="Header">
    <b-navbar toggleable="md" class="section">
      <b-navbar-brand href="/" :aria-label="translations.fr.logoAlt">
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 113 61" class="Header_Logo" :alt="translations.fr.logoAlt">
          <defs />
          <path fill-rule="evenodd"
            d="M36.003247 36.8659731c5.150209 0 8.888019 3.6081829 8.888019 8.579634 0 3.2296521-1.583539 5.8769797-4.10133 7.3401546l4.431584 6.4728373c.342279.4999313.21162 1.1809684-.291778 1.5204918-.189576.1285652-.405203.1898625-.618426.1898625-.352699 0-.699787-.1679706-.912609-.4796316l-4.678474-6.8334566c-.757903.2117544-1.5639.3415136-2.413986.3653957l3.429198 5.2918689c.329053.5082901.181159 1.1853468-.330655 1.5129292C39.220023 60.9430811 39.013614 61 38.809209 61c-.361917 0-.717021-.1771254-.927438-.5023196l-4.51976-6.9739627c-.218032-.3375333-.233663-.7658185-.04048-1.1172829.193183-.3514645.564318-.5695874.967518-.5695874h1.714198c3.872877 0 6.683649-2.6883252 6.683649-6.3912403s-2.810772-6.3904442-6.683649-6.3904442h-9.03992v20.8191955c0 .6038183-.493378 1.0945949-1.102185 1.0945949-.608406 0-1.102185-.4907766-1.102185-1.0945949V37.960568c0-.6046144.493779-1.0945949 1.102185-1.0945949zm.338952 4.3824396c2.389136 0 4.057242 1.7258777 4.057242 4.197274 0 2.4570671-1.668106 4.17379-4.057242 4.17379h-2.276112c-.608406 0-1.102185-.4903785-1.102185-1.0945949 0-.6050125.493779-1.094595 1.102185-1.094595h2.276112c1.672515 0 1.852873-1.3883444 1.852873-1.9846001 0-.4712728-.133465-2.0080841-1.852873-2.0080841h-4.875265V59.874438c0 .6038184-.493779 1.0945949-1.102185 1.0945949-.608806 0-1.102185-.4907765-1.102185-1.0945949V42.3430077c0-.6042164.493379-1.094595 1.102185-1.094595zm-24.390631-4.3824794c2.509375 0 4.801118.8848307 6.452792 2.4924921 1.652075 1.6076615 2.561878 3.8350626 2.561878 6.2714319 0 5.0610089-3.791115 8.7332754-9.01467 8.7332754h-1.732634c-.608807 0-1.102185-.4895825-1.102185-1.094595 0-.6038183.493378-1.0945949 1.102185-1.0945949h1.732634c3.946223 0 6.810301-2.7520106 6.810301-6.5440855 0-3.8091903-2.864078-6.5747342-6.810301-6.5747342H3.237895v20.8191955c0 .6042164-.493378 1.0945949-1.102185 1.0945949s-1.102185-.4903785-1.102185-1.0945949V37.9605282c0-.6046144.493378-1.0945949 1.102185-1.0945949h9.815858zm59.884551 12.6764839c.602395.0871696 1.019622.6428257.931848 1.2406736-.880145 5.9971861-5.907711 10.1857033-12.225836 10.1857033-6.318125 0-11.345691-4.1885172-12.225435-10.1857033-.088175-.5978479.329052-1.153504.931447-1.2406736.602394-.0867715 1.162304.3275824 1.249677.9250322.718224 4.8938344 4.848411 8.3121548 10.044311 8.3121548 5.1959 0 9.326087-3.4183204 10.044712-8.3121548.087373-.5974498.646882-1.0118037 1.249276-.9250322zm-59.884551-8.2941239c2.656066 0 4.511343 1.8019023 4.511343 4.381564 0 2.5613521-1.855277 4.3513133-4.511343 4.3513133h-1.732634c-.608807 0-1.102185-.4907765-1.102185-1.0945949 0-.6050124.493378-1.0945949 1.102185-1.0945949h1.732634c1.444865 0 2.306974-.8088061 2.306974-2.1621235 0-1.3931208-.840867-2.1923741-2.306974-2.1923741H7.741222v16.4368354c0 .6042164-.493378 1.0945949-1.102185 1.0945949-.608406 0-1.102185-.4903785-1.102185-1.0945949V42.3428883c0-.6042164.493779-1.094595 1.102185-1.094595h5.312531zm43.106091 9.1204436c.603196 2.4849295 2.704561 4.0281093 5.484472 4.0281093 2.731415 0 4.883681-1.5821872 5.482869-4.0293034.143484-.587897.740668-.9477202 1.331038-.8056219.591974.1428944.954693.7347717.810808 1.3222707-.848081 3.4636963-3.840814 5.7018444-7.624715 5.7018444-3.792318 0-6.786253-2.2389441-7.627119-5.7042326-.142683-.587499.221238-1.1781822.813212-1.3206786.591973-.1413022 1.186752.2201131 1.329435.8076121zm5.484472-9.120563c3.701738 0 6.676435 2.1637157 7.578623 5.511186.157513.5839166-.191579 1.1841526-.779946 1.3401822-.095389.0250761-.19158.0374152-.285766.0374152-.486565 0-.931847-.322806-1.063709-.8115924-.646481-2.3981579-2.73422-3.8880011-5.449202-3.8880011-2.721795 0-4.810336 1.4890471-5.450405 3.8848169-.15671.5847127-.760707.9314007-1.347871.7773614-.588768-.1544374-.939062-.7538774-.782752-1.3385901.894573-3.3490624 3.870472-5.5127781 7.581028-5.5127781zm0-4.381962c6.227545 0 11.243488 4.1124927 12.197379 10.0014133.096592.5970518-.312219 1.1590766-.91341 1.2546048-.601994.0955283-1.166312-.3100688-1.263305-.9063246-.777942-4.8054707-4.898911-8.1605036-10.020664-8.1605036-5.122154 0-9.243123 3.355829-10.021065 8.1609017-.087373.5381426-.555501.9206538-1.086955.9206538-.057714 0-.117032-.0047764-.175949-.0139312-.601191-.0955283-1.010002-.657553-.913811-1.2542068.954292-5.8893187 5.969834-10.0026074 12.19778-10.0026074zm51.355684-32.5711645c.608807 0 1.102185.4899804 1.102185 1.0945949 0 .6042164-.493378 1.0945949-1.102185 1.0945949H96.457207v19.7249986h15.440608c.608807 0 1.102185.4899804 1.102185 1.0945949 0 .6042164-.493378 1.0945949-1.102185 1.0945949H95.355022c-.608807 0-1.102185-.4903785-1.102185-1.0945949V5.3896423c0-.6046145.493378-1.0945949 1.102185-1.0945949h16.542793zm-96.04423 16.3727027l.120517.0067759c.6052.0644816 1.042467.6050124.977137 1.2056465-.432457 3.9600455-3.698531 6.5182133-8.321696 6.5182133-4.497716 0-7.713691-2.3925855-8.603455-6.4007931-.13106-.5898871.244485-1.1738038.839264-1.3043591.59518-.1289632 1.182344.2431991 1.313403.8334843.93826 4.2263305 4.823562 4.682478 6.450788 4.682478 2.722597 0 5.763024-1.1988799 6.130152-4.5642618.065329-.6018282.606803-1.0372779 1.214407-.9704081zm5.687433-3.6951441c.602795-.0879657 1.163105.3216118 1.253685.9194597.739867 4.8970187 4.841197 8.3173293 9.974573 8.3173293 2.134231 0 4.070068-.4597299 5.753806-1.3648604.53466-.287779 1.203987-.0911499 1.494162.4406242.289774.5321722.090579 1.1968898-.444481 1.4846688-2.009985 1.0806637-4.298521 1.6287572-6.803487 1.6287572-3.010368 0-5.879255-1.0185703-8.079617-2.8670426-2.193548-1.844492-3.641218-4.4420652-4.075278-7.3142823-.089778-.5978479.324643-1.1554942.926637-1.2446539zM50.428082 4.2952464c.608406 0 1.102184.4895824 1.102184 1.0945949 0 .6042164-.493778 1.0945949-1.102184 1.0945949h-3.406353v19.7249986h14.639019c.608807 0 1.102185.4895824 1.102185 1.0945949 0 .6038184-.493378 1.0945949-1.102185 1.0945949H45.919544c-.608807 0-1.102185-.4907765-1.102185-1.0945949V5.3898413c0-.6050125.493378-1.0945949 1.102185-1.0945949h4.508538zm18.102485.0444604c.468529-.1369238.973129.0497543 1.237653.4585358l14.033419 21.690095c.329052.5086881.180358 1.1865409-.331457 1.5129292-.184365.1174201-.390775.173941-.59518.173941-.362318 0-.717422-.1779214-.927839-.5035136L69.943367 9.1185092v17.9613076c0 .6050125-.493778 1.094595-1.102184 1.094595-.608807 0-1.102185-.4895825-1.102185-1.094595V5.3897219c0-.4856021.321838-.9134892.791569-1.0500151zm4.813903 13.6892828c.608806 0 1.102184.4903785 1.102184 1.0945949v7.956312c0 .6050124-.493378 1.0945949-1.102184 1.0945949-.608807 0-1.102185-.4895825-1.102185-1.0945949v-7.956312c0-.6042164.493378-1.0945949 1.102185-1.0945949zM88.175029 4.2952464c.608806 0 1.102185.4903785 1.102185 1.0945949v21.690095c0 .4860001-.32264.9134892-.79197 1.0504131-.102604.0302506-.20681.0441818-.310215.0441818-.368331 0-.72103-.1834939-.927038-.5031156L73.214572 5.9813206c-.329052-.5082901-.180358-1.1853468.331457-1.5121331.511815-.3263883 1.193967-.1795136 1.523019.3291745l12.003796 18.5527869V5.3898413c0-.6042164.493378-1.0945949 1.102185-1.0945949zM26.019776 16.9878507c.591974-.1397101 1.186352.2240934 1.327031.8123884.592775 2.4833374 2.670894 4.0257211 5.422349 4.0257211 1.682535 0 3.444027-.6312827 4.832379-1.7322462.475342-.3777347 1.169118-.300118 1.549071.1719509.379953.472467.302199 1.1614647-.173544 1.5384034-1.771913 1.4054599-4.034398 2.2110818-6.207906 2.2110818-3.768671 0-6.73936-2.2413324-7.567401-5.7094071-.140679-.5886931.225647-1.1785802.818021-1.3178923zM1.476884 13.4914359c.546283-.2674792 1.207193-.046172 1.476928.495951.887359 1.7831946 2.914577 2.6142907 4.781077 3.1926348l.301799.0887617c2.193147.645214 4.460843 1.3131159 4.460843 3.6794311 0 1.8635976-1.505785 3.066856-3.836005 3.066856-1.592356 0-2.819188-.5293859-3.646829-1.5742265-.376346-.4748552-.293381-1.1630569.184766-1.5368113.47895-.3741525 1.171523-.2917593 1.547869.1834939.251298.3168355.722632.738354 1.914194.738354.744276 0 1.631635-.1524472 1.631635-.8776661 0-.5090861-.27214-.8123884-2.882514-1.5805951l-.318632-.0939361c-2.190342-.6778528-4.851217-1.7772241-6.114521-4.3162863-.269735-.541725-.046091-1.1980839.49939-1.4659611zm56.777111 2.7814652c.608807 0 1.102185.4895824 1.102185 1.0945949 0 .6038184-.493378 1.0945949-1.102185 1.0945949h-6.728939v3.3637897h10.135692c.608807 0 1.102185.4895825 1.102185 1.094595 0 .6042163-.493378 1.0945949-1.102185 1.0945949H50.422871c-.608807 0-1.102185-.4903786-1.102185-1.0945949V17.367496c0-.6050125.493378-1.0945949 1.102185-1.0945949h7.831124zm49.435478-.000199c.608807 0 1.102185.4907765 1.102185 1.0945949 0 .6050124-.493378 1.0945949-1.102185 1.0945949h-6.728939v3.3637897h10.937281c.608807 0 1.102185.4907766 1.102185 1.0945949 0 .6050125-.493378 1.094595-1.102185 1.094595H99.858349c-.608807 0-1.102185-.4895825-1.102185-1.094595V17.367297c0-.6038184.493378-1.0945949 1.102185-1.0945949h7.831124zM8.599283 8.6775666c1.582737 0 2.797546.5341623 3.609956 1.5857695.370334.4796316.278953 1.1670372-.204004 1.5348211-.482958.3677839-1.17513.2774301-1.545063-.2022015-.24208-.3132532-.697783-.7291992-1.86129-.7291992-.492175 0-1.633638.0823931-1.633638.8466194 0 .6010321.885355.9405555 2.904958 1.5718383l.444081.1401081c2.357072.7483049 4.920955 1.8616075 6.077648 4.4436574.247691.5516758-.002806 1.1984819-.559109 1.4444673-.145488.0644815-.297389.0947322-.447286.0947322-.422037 0-.824836-.242005-1.007598-.6499904-.800787-1.787175-2.747847-2.6166789-4.733383-3.2479617l-.436064-.1369238c-2.286934-.714472-4.447617-1.3899366-4.447617-3.6599274 0-2.0968459 1.92702-3.0358093 3.836004-3.0358093zM32.801139 4.295326c2.429616 0 4.779875.6093908 6.796673 1.7628949.527847.3017101.709407.9712042.405604 1.4942215-.303802.5242115-.978339.7045211-1.505384.402811-1.682936-.9624475-3.652841-1.4707376-5.696893-1.4707376-5.107324 0-9.215869 3.355033-9.991406 8.1605037-.086572.5377446-.5547.9210519-1.086955.9210519-.057714 0-.116631-.0047764-.175548-.0139312-.601192-.0955283-1.010403-.656757-.913811-1.2538088.950283-5.8897167 5.953802-10.0030054 12.16772-10.0030054zm.00012 4.382161c2.136636 0 4.17187.7423344 5.886069 2.1473962.469731.3845014.536263 1.0750913.148694 1.5407916-.386766.4664965-1.082145.5325702-1.551475.1476708-1.333444-1.0922067-2.841633-1.6466688-4.483288-1.6466688-2.703759 0-4.779875 1.4878531-5.418741 3.8832248-.130659.4903785-.576343.8147767-1.064511.8147767-.093385 0-.188373-.0119411-.28256-.0366192-.588767-.1548354-.939462-.7542754-.783553-1.337794.892169-3.3490625 3.855643-5.5127781 7.549365-5.5127781zm79.096556-.0000796c.608807 0 1.102185.4907766 1.102185 1.0945949 0 .6050125-.493378 1.0945949-1.102185 1.0945949h-10.937281v2.7233522c0 .6050125-.493378 1.0945949-1.102185 1.0945949s-1.102185-.4895824-1.102185-1.0945949V9.7720023c0-.6038183.493378-1.0945949 1.102185-1.0945949h12.039466zm-50.237067.000199c.608807 0 1.102185.4895825 1.102185 1.0945949 0 .6038184-.493378 1.094595-1.102185 1.094595H51.525056v2.7233521c0 .6038184-.493779 1.094595-1.102185 1.094595-.608807 0-1.102185-.4907766-1.102185-1.094595V9.7722013c0-.6050124.493378-1.0945949 1.102185-1.0945949h11.237877zm22.010833-4.3822406c.608807 0 1.102185.4903785 1.102185 1.0945949v7.9559139c0 .6050125-.493378 1.094595-1.102185 1.094595s-1.102185-.4895825-1.102185-1.094595V5.3899607c0-.6042164.493378-1.0945949 1.102185-1.0945949zM8.629383 4.295326c4.471263 0 7.675615 2.3921874 8.570589 6.3980068.131862.5906832-.242881 1.1753959-.837259 1.3059513-.080159.0179115-.160318.0266683-.239675.0266683-.505402 0-.961106-.3474842-1.074931-.8585605-.664918-2.975706-3.004356-4.6828761-6.418724-4.6828761-3.488115 0-5.838775 1.7473716-6.134561 4.5602815-.063326.6010321-.6052 1.037676-1.2108.9747865-.605601-.0628894-1.044872-.6018282-.981546-1.2024622C.719302 6.855086 3.987781 4.295326 8.629383 4.295326zM53.696561.5031715l2.453664 3.7920749h5.510523c.608807 0 1.102185.4895824 1.102185 1.0945949 0 .6042164-.493378 1.0945949-1.102185 1.0945949h-6.112116c-.375544 0-.724636-.1898624-.927438-.5031156l-2.778709-4.2951905c-.329052-.5082901-.180758-1.1853468.331457-1.5125312.511815-.3259902 1.193967-.1799116 1.522619.3295726z" />
        </svg>
      </b-navbar-brand>
      <div class="Header_Mobile" v-if="isVisible">
        <b-button size="md" class="U--mr--16" v-bind:href="connectionUrl" target="_blank">
          {{ translations.fr.connexion }}
        </b-button>
        <b-navbar-toggle target="nav-collapse" class="Header_HamburgerBtn">
          <span />
          <span />
          <span />
        </b-navbar-toggle>
      </div>
      <b-collapse id="nav-collapse" is-nav ref="navCollapse">
        <b-navbar-nav>
          <b-nav-item to="/a-propos" @click="closeMenu">{{ translations.fr.about }}</b-nav-item>
          <b-nav-item to="/equipe" @click="closeMenu">{{ translations.fr.team }}</b-nav-item>
          <b-nav-item to="/fonctionnalites" @click="closeMenu">{{
            translations.fr.features
          }}</b-nav-item>
          <b-nav-item to="/offres-de-spectacles" @click="closeMenu" class="offers-link">{{
            translations.fr.offers
          }}</b-nav-item>
        </b-navbar-nav>
        <a v-if="!isVisible" class="btn btn-secondary btn-lg" size="lg" :href="connectionUrl" target="_blank">{{
          translations.fr.connexion }}</a>
      </b-collapse>
    </b-navbar>
  </header>
</template>

<script lang="ts" setup>

import translations from '@/dictionaries/navigation.json';
import { onMounted, onUnmounted, ref } from 'vue';
import { Collapse } from 'bootstrap';

const isVisible = ref(false);
const connectionUrl = process.env.VUE_APP_LOGIN_URL;

const navCollapse = ref(null);
let bsCollapse:any = null;

const showButtonsDependingScreenWidth = () => {
  isVisible.value = window.innerWidth < 768;
};

const closeMenu = () => {
  if (bsCollapse) {
    bsCollapse.hide(); // Bootstrap handles animation
  }
};

onMounted(() => {
  showButtonsDependingScreenWidth();
  window.addEventListener('resize', showButtonsDependingScreenWidth);
  if (navCollapse.value) {
    bsCollapse = new Collapse(navCollapse.value.$el, { toggle: false });
  }
});

onUnmounted(() => {
  window.removeEventListener('resize', showButtonsDependingScreenWidth);
});

</script>

<style lang="scss" scoped>
@import "../styles/variables";
@import "../styles/typographies";

.Header {
  padding: 5px 0;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;

  @media ($bp-min-md) {
    padding: 0;
    height: 140px;
  }

  &.page {
    &-home {
      background-color: $home-primary;

      ::v-deep(.nav-link) {
        color: $home-nav-color;

        &:hover {
          &:before {
            background-color: $home-secondary;
          }
        }
      }

      .btn {
        background-color: $home-secondary;
        color: $home-primary;
        border-radius: 5px;

        &:hover {
          background-color: $sp-navy-blue;
        }
      }

      .Header_Logo {
        fill: $home-secondary;
      }

      .Header_HamburgerBtn>span {
        background-color: $home-nav-color;
      }
    }

    &-about {
      background-color: $about-primary;

      ::v-deep(.nav-link) {
        color: $about-nav-color;

        &.router-link-exact-active,
        &:hover {
          &:before {
            background-color: $about-secondary;
            opacity: 1;
          }
        }
      }

      .btn {
        background-color: $sp-white;
        color: $about-primary;
        border-radius: 5px;

        &:hover {
          background-color: $about-secondary;
        }
      }

      .Header_Logo {
        fill: $about-secondary;
      }
    }

    &-team {
      background-color: $team-primary;

      ::v-deep(.nav-link) {
        color: $team-nav-color;

        &.router-link-exact-active,
        &:hover {
          &:before {
            background-color: $team-secondary;
            opacity: 1;
          }
        }
      }

      .btn {
        background-color: $sp-white;
        color: $team-primary;
        border-radius: 5px;

        &:hover {
          background-color: $team-secondary;
        }
      }

      .Header_Logo {
        fill: $team-secondary;
      }
    }

    &-features {
      background-color: $features-primary;

      ::v-deep(.nav-link) {
        color: $features-nav-color;

        &.router-link-exact-active,
        &:hover {
          &:before {
            background-color: $features-secondary;
            opacity: 1;
          }
        }
      }

      .btn {
        background-color: $sp-white;
        color: $features-primary;
        border-radius: 5px;

        &:hover {
          background-color: $features-secondary;
        }
      }

      .Header_Logo {
        fill: $features-secondary;
      }
    }

    &-offers {
      background-color: $offers-primary;

      ::v-deep(.nav-link) {
        color: $offers-nav-color;

        &.router-link-exact-active,
        &:hover {
          &:before {
            background-color: $offers-secondary;
            opacity: 1;
          }
        }
      }

      .btn {
        background-color: $sp-white;
        color: $offers-primary;
        border-radius: 5px;

        &:hover {
          background-color: $offers-secondary;
        }
      }

      .Header_Logo {
        fill: $offers-secondary;
      }
    }

    &-offer {
      background-color: $offers-primary;

      :deep(.offers-link>.nav-link) {
        &:before {
            background-color: $offers-secondary;
            opacity: 1;
          }
      }

      ::v-deep(.nav-link) {
        color: $offers-nav-color;

        &:hover {
          &:before {
            background-color: $offers-secondary;
            opacity: 1;
          }
        }
      }

      .btn {
        background-color: $sp-white;
        color: $offers-primary;
        border-radius: 5px;

        &:hover {
          background-color: $offers-secondary;
        }
      }

      .Header_Logo {
        fill: $offers-secondary;
      }
    }
  }

  &_Logo {
    height: 37px;

    @media ($bp-min-md) {
      height: 61px;
    }
  }

  &_Mobile {
    display: flex;
    align-items: center;
  }

  &_HamburgerBtn {
    width: 20px;
    height: 14px;
    padding: 0;
    position: relative;
    border: none;
    cursor: pointer;

    span {
      display: block;
      position: absolute;
      height: 2px;
      width: 100%;
      border-radius: 9px;
      background-color: $sp-white;

      &:nth-child(1) {
        top: 0px;
      }

      &:nth-child(2) {
        top: 6px;
      }

      &:nth-child(3) {
        top: 12px;
      }
    }
  }
}

.btn {
  @extend .typo_btn;
  border: none;
  padding: 0.5rem 1rem;
  transition: background-color 0.2s ease-in-out;

  @media ($bp-min-md) {
    padding: 1rem 2rem;
  }

  &:hover {
    transition: background-color 0.2s ease-in-out;
  }
}

.navbar-nav :deep(.nav-link) {
  @extend .typo_nav;
  position: relative;
  padding: 10px 0;
  @extend %_active;

  &:before {
    opacity: 0;
    transition: all 0.2s ease-in-out;
  }

  &.router-link-active,
  &:hover {
    &:before {
      opacity: 1;
      transition: all 0.2s ease-in-out;
      background-color: $home-secondary;
    }
  }

  @media ($bp-min-md) {
    padding: 0.5rem 0rem;
  }
}

li.nav-item {
  margin-right: 5px;

  @media ($bp-min-lg) {
    margin-right: 40px;
  }
}

#nav-collapse {
  justify-content: flex-end;

  @media ($bp-max-sm) {
    padding-top: 10px;
  }
  
}

%_active {
  @media ($bp-min-md) {
    &:before {
      content: "";
      position: absolute;
      // width: calc(100% - 2rem);
      width: 100%;
      height: 3px;
      //left: 1rem;
      bottom: 0;
    }
  }
}
</style>
